(function () {
  function qs(selector) {
    return document.querySelector(selector);
  }

  function show(el) {
    if (el) el.removeAttribute("hidden");
  }

  function hide(el) {
    if (el) el.setAttribute("hidden", "");
  }

  var desktopMedia = window.matchMedia("(min-width: 1025px)");
  var header = qs("[data-header-shell]");

  function openDesktopMenu(menuKey, pinMenu) {
    if (!header) return;
    header.classList.add("is-desktop-open");
    header.setAttribute("data-desktop-menu", menuKey);
    if (pinMenu) {
      header.setAttribute("data-desktop-pinned", "true");
    }
  }

  function closeDesktopMenu(forceClose) {
    if (!header) return;
    var isPinned = header.getAttribute("data-desktop-pinned") === "true";
    if (isPinned && !forceClose) return;
    header.classList.remove("is-desktop-open");
    header.removeAttribute("data-desktop-menu");
    header.removeAttribute("data-desktop-pinned");
  }

  if (header) {
    var desktopTriggers = header.querySelectorAll("[data-desktop-menu]");

    desktopTriggers.forEach(function (trigger) {
      var menuKey = trigger.getAttribute("data-desktop-menu");

      trigger.addEventListener("mouseenter", function () {
        if (desktopMedia.matches) openDesktopMenu(menuKey, false);
      });

      trigger.addEventListener("focus", function () {
        if (desktopMedia.matches) openDesktopMenu(menuKey, false);
      });

      trigger.addEventListener("click", function (event) {
        if (!desktopMedia.matches) return;
        var currentMenu = header.getAttribute("data-desktop-menu");
        var isOpen = header.classList.contains("is-desktop-open");

        if (!isOpen || currentMenu !== menuKey) {
          event.preventDefault();
          openDesktopMenu(menuKey, true);
          return;
        }

        if (header.getAttribute("data-desktop-pinned") === "true") {
          event.preventDefault();
          closeDesktopMenu(true);
        }
      });
    });

    header.addEventListener("mouseleave", function () {
      if (desktopMedia.matches) closeDesktopMenu(false);
    });

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener("change", function (event) {
        if (!event.matches) {
          closeDesktopMenu(true);
        }
      });
    }
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    var menuButton = target.closest("[data-menu-toggle]");
    var openSearch = target.closest("[data-open-search]");
    var openCart = target.closest("[data-open-cart]");
    var closeSearch = target.closest(".close-search");
    var closeCart = target.closest(".close-cart");

    if (menuButton) {
      if (header) {
        if (desktopMedia.matches) {
          var currentMenu = header.getAttribute("data-desktop-menu");
          if (header.classList.contains("is-desktop-open") && currentMenu === "all") {
            closeDesktopMenu(true);
          } else {
            openDesktopMenu("all", true);
          }
        } else {
          header.classList.toggle("is-mobile-open");
        }
      }
    }

    if (openSearch) {
      event.preventDefault();
      show(qs("#SearchOverlay"));
      var searchInput = qs("#SearchOverlay input[type='search']");
      if (searchInput) searchInput.focus();
    }

    if (closeSearch) {
      hide(qs("#SearchOverlay"));
    }

    if (openCart) {
      event.preventDefault();
      show(qs("#CartDrawer"));
    }

    if (closeCart) {
      hide(qs("#CartDrawer"));
    }

    if (header && desktopMedia.matches && !target.closest("[data-header-shell]")) {
      closeDesktopMenu(true);
    }
  });
})();
